import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

import { HUIModal } from 'root/widgets/common-components';

import { EVENT_NAMES, emit } from 'root/widgets/events';
import { PGLogin } from 'root/widgets/pg-login';
import { VIEW } from 'root/widgets/pg-login/constants';
import { PGLoginModalProps } from './types';

const PGLoginModal: React.FC<PGLoginModalProps> = ({ shouldShow = true, className, ...props }) => {
  const [isBackVisible, setBackVisible] = useState(false);
  const [isCloseVisible, setCloseVisible] = useState(true);
  const [title, setTitle] = useState('');

  const { context } = props;

  const handleBack = () => {
    emit(EVENT_NAMES.PG_LOGIN.BACK, context);
  };

  const handleClose = () => {
    emit(EVENT_NAMES.PG_LOGIN.CLOSE, context);
    props.onClose();
  };

  const onEdgeOfFlow = (isEdge: boolean) => {
    setCloseVisible(isEdge);
    setBackVisible(!isEdge);
  };

  useEffect(() => {
    if (shouldShow) {
      emit(EVENT_NAMES.PG_LOGIN.MODAL_VIEW_ACTIVE, context);
    }
  }, [shouldShow]);

  const handleViewChange = (view: VIEW, translation: Record<string, string>) => {
    switch (view) {
      case VIEW.LOGIN:
        setTitle(translation.loginTitle);
        break;
      case VIEW.SIGNUP:
        setTitle(translation.signUpTitle);
        break;
      case VIEW.VERIFY_EMAIL:
        setTitle(translation.verifyEmailTitle);
        break;
      case VIEW.SET_PASSWORD:
        setTitle(translation.setPasswordModalTitle);
        break;
      case VIEW.OTP_LOGIN:
        setTitle(translation.otpLoginTitle);
        break;
      case VIEW.PASSWORD_LOGIN:
        setTitle(translation.passwordLoginTitle);
        break;
      case VIEW.FORGOT_PASSWORD:
        setTitle(translation.forgotPasswordTitle);
        break;
      default:
        return '';
    }
    return '';
  };

  return (
    <HUIModal
      className={classNames('pg-login-modal-root', className)}
      show={shouldShow}
      onBack={handleBack}
      onHide={handleClose}
    >
      <HUIModal.Header backButton={isBackVisible} closeButton={isCloseVisible}>
        {title}
      </HUIModal.Header>
      <HUIModal.Body>
        <PGLogin onViewChange={handleViewChange} {...props} onEdgeOfFlow={onEdgeOfFlow} />
      </HUIModal.Body>
    </HUIModal>
  );
};

export default PGLoginModal;
